import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import localeNl from '@angular/common/locales/nl';
import { provideRouter } from '@angular/router';
import { provideTranslateService, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { provideMarkdown } from 'ngx-markdown';
import { routes } from './app.routes';
import { appConfigInitializer } from './core/config/app-config';
import { authInterceptor, errorInterceptor, loadingInterceptor } from './core/interceptors';
import { I18nService } from './core/services';

registerLocaleData(localeNl);

function translationInitializer(): Promise<unknown> {
  const translate = inject(TranslateService);
  const language = localStorage.getItem('language') ?? 'nl';
  translate.setFallbackLang('nl');
  return firstValueFrom(translate.use(language));
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([loadingInterceptor, authInterceptor, errorInterceptor])),
    provideMarkdown(),
    provideAppInitializer(appConfigInitializer),
    provideTranslateService({
      lang: 'nl',
      fallbackLang: 'nl',
      loader: { provide: TranslateLoader, useExisting: I18nService },
    }),
    provideAppInitializer(translationInitializer),
  ],
};
